// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { Store, State } from '@ngrx/store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesFacadeService } from '@app/access-management/state/roles.facade';
import { Role, ScopeCategory, readParameterFromRouterState, GoAction } from '@app/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { OrganizationDetailsFacadeService } from '@app/access-management/state/organization-details/organization-details.facade';
import { SelectRoleAction } from '@app/access-management/state';

@Component({
  selector: 'app-organization-roles-list',
  templateUrl: './organization-roles-list.component.html',
  styleUrls: ['./organization-roles-list.component.scss']
})
export class OrganizationRolesListComponent implements AfterViewInit {
  organization$: Observable<ScopeCategory>;
  columns: any[] = [];
  organizationId: any = '';

  constructor(
    private store: Store<any>,
    private activatedRoute: ActivatedRoute,
    private organizationDetailsFacade: OrganizationDetailsFacadeService,
    public roleFacade: RolesFacadeService
  ) {
    this.organizationId = readParameterFromRouterState(this.activatedRoute, 'orgId');
    if (!this.organizationId) {
      throw new Error('organization id not in route');
    }
    this.roleFacade.loadOrganizationRoles(this.organizationId);
    this.organizationDetailsFacade.initialize(this.organizationId);
    this.organization$ = this.organizationDetailsFacade.organization$;
  }

  ngAfterViewInit() {
    this.columns = [
      {
        name: 'Role Name',
        prop: 'name',
        cellClass: 'text-info',
        flexGrow: 2
      },
      {
        name: 'Users',
        prop: 'numberOfUsers',
        flexGrow: 1
      },
      {
        name: 'Description',
        prop: 'description',
        flexGrow: 2
      },
      {
        name: 'Category',
        prop: 'category',
        flexGrow: 1
      }
    ];
  }

  onRowClicked({ selected }: { [selected: string]: Role[] }) {
    if (selected.length < 1) {
      return;
    }
    const selectedRole = selected[0];
    this.store.dispatch(new SelectRoleAction(selectedRole));
    this.store.dispatch(new GoAction(['/iam/organizations/' + this.organizationId + '/roles/', selectedRole.id]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organization-roles-list/organization-roles-list.component.ts